export enum ERuntimeSettings {
  /** Дефолтный стейт калькулятора offer-calculator **/
  offerCalculatorInitialValues = 'mortgage-promo-frontend.calculatorInitialValues',
  /** Дефолтный стейт **/
  initialState = 'mortgage-calculator-micro-frontend.initialCalculatorState',
  /** Имя ивента для всплытия из калькулятора СИ **/
  subsidizedCalculatorEventName = 'mortgage-calculator-micro-frontend.eventNameOnCalculateSubsidizedMortgage',
  /** Имя ивента для передачи аналитики из калькулятора офферов **/
  offerCalculatorAnalyticSendEventName = 'mortgage-calculator-micro-frontend.eventNameOnSendAnalyticOfferCalculator',
  /** Имя ивента для всплытия из калькулятора офферов формы **/
  offerCalculatorOnSubmitFormEventName = 'mortgage-calculator-micro-frontend.eventNameOnSubmitFormOfferCalculator',
  /** Имя РС, хранящей в себе опции первоначального взноса **/
  downPaymentOptions = 'mortgage-calculator-micro-frontend.downPaymentOptions',
  /** Имя РС, хранящей в себе минимальный первоначальный взнос **/
  minDownPayment = 'mortgage-calculator-micro-frontend.minDownPayment',
  /** Имя РС, хранящей в себе дефолтные значения  **/
  miniCalculatorDefaultParams = 'mortgage-calculator-micro-frontend.miniCalculatorDefaultParams',

  /** Feature Toggle для показа поля страхования жизни **/
  lifeInsuranceFieldEnabled = 'mortgage-calculator-micro-frontend.lifeInsuranceField.Enabled',

  /** Feature Toggle для показа поля программы **/
  programFilterFieldEnabled = 'Transaction.isMortgageGovProgramsFilters.Enabled',

  /** Манифест виджета авторизации **/
  loginWidgetManifest = 'loginWidgetB2CManifest',

  /** Конфиг кнопки для перехода из лэндинга СИ на тильде **/
  linkButtonConfig = 'mortgage-calculator-micro-frontend.linkButtonConfig',

  enableGetOffersV3 = 'mortgage-calculator-micro-frontend.enableGetOffersV3.Enabled',

  /* PLATFORM */
  projectName = 'projectName',
  soprApiBaseUrl = 'sopr-api.browserUrl',
  assetsBaseUrl = 'web.manifest.assetsBaseUrl',
  isWebView = 'web.isWebView',
  webPlatform = 'web.platform',
  applicationContextCustom = 'applicationContext.custom',
}
